import "url-polyfill";
import "/polyfills/nodelist-foreach";
import events from "/events";
import notify from "/utils/notify";

let savedTestCategories = [];
let savedFingerprint;

export const init = () => {
  events.on("setup:ready", config => {
    savedTestCategories = config.test_categories || [];
    savedFingerprint = config.fingerprint;
    document.querySelectorAll(".js-adjust-link-track").forEach(node => {
      const platform = node.dataset.platform;

      var adjustedUrl = adjustUrl(
        node.dataset.buttonCode,
        platform
      );

      node.setAttribute("href", adjustedUrl);
    });
  });
};

export const adjustUrl = (buttonCode, platform, testCategories = savedTestCategories, fingerprint = savedFingerprint) => {
  if (!fingerprint) {
    notify("Fingerprint is null. Did you wait for 'setup:ready' before calling the method?");
    return;
  }

  let appCode;

  if (platform === "ios") {
    appCode = "ql5itzy";
  } else if (platform === "android") {
    appCode = "w1rynlu";
  } else {
    appCode = "ql5itzy_w1rynlu";
  }

  const url = new URL(`https://app.adjust.com/${appCode}`);
  const location = new URL(window.location.href);
  const pathname = window.location.pathname.replace("/", "").replace(".html", "");

  if (location.searchParams.has("utm_source")) {
    url.searchParams.set("campaign", location.searchParams.get("utm_source"));
  } else {
    url.searchParams.set("campaign", "organic");
  }

  const utmCampaign = location.searchParams.has("utm_campaign") ? location.searchParams.get("utm_campaign") : "";
  const utmTerm = location.searchParams.has("utm_term") ? location.searchParams.get("utm_term") : "";
  const utmContent = location.searchParams.has("utm_content") ? location.searchParams.get("utm_content") : "";
  const code = buttonCode || "body-20190405-adjust_link";
  const categories = Object.keys(testCategories)
    .map(key => `${key}-${testCategories[key]}`)
    .join(",")
    || "";

  const label = `${utmCampaign}__${utmTerm}__${utmContent}__${code}__${categories}__${pathname}__${fingerprint}`;
  url.searchParams.set("label", label);

  return url.href;
};
